'use client';

import React from 'react';

import {useCommonData} from '@udemy-v2/common-data';
import {Header as ReactHeader} from '@udemy-v2/react-header';

import {useIsOrgHost} from '@/lib/hooks/use-is-org-host';
import {useOrgBranding} from '@/lib/hooks/use-org-branding';

export const Header = () => {
    const commonData = useCommonData();
    const isOrgHost = useIsOrgHost();
    const orgBranding = useOrgBranding();

    if (
        isOrgHost &&
        !commonData?.page?.isLoading &&
        !commonData?.user &&
        orgBranding?.isAnonymous
    ) {
        return (
            <ReactHeader
                variant="org-logged-out"
                organization={{name: orgBranding?.name, logoUrl: orgBranding?.logoUrl}}
            />
        );
    }

    return <ReactHeader />;
};

export default Header;
